import React from 'react'
import { useSelector } from 'react-redux';

import { Link } from "react-router-dom";
import ProjectItem from './ProjectItem'

import './style.css'

const Project = () => {
   const project = useSelector(state => state.project.project);
   return (
      <div className='project_component _container' id='project'>
         <div className="project_content--text">
            <Link to="project"><div className="project--front_title">Recent Projects</div></Link>
            <div className="project--subb">With tools to make every part of your process more human and a support team excited to help you, getting started with us never been easier.</div>
         </div>
         <div className="project_block">
            {project.map(el => (
               <ProjectItem key={el.id} item={el} />
            ))}
         </div>
      </div>
   )
}

export default Project
